/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useStyles } from './styles';
import useAppClient from '../../../store/models/appclient/useAppClient';
import useUIStates from '../../../store/models/uistates/useUIStates.js';
import getCommonUIStyles from '../../../commons/uiStyles';

function WidgetHeader (props) {
    const {
        widget = {},
        widgetTheme = {},
        isShowCloseButton = true,
        isShowBackButton = true,
        goToBackPage = () => {},
    } = props;

    const {
        closeWidget,
    } = useAppClient();

    const {
        isDirectLink,
    } = useUIStates();

    const classes = useStyles({
        widget,
        widgetTheme,
        isShowCloseButton,
        isShowBackButton,
        commonUIStyles: getCommonUIStyles({ widgetTheme, widget}),
        isDirectLink,
    });

    return (
        <header className={classNames([classes.header, 'ecal-header'])}>
            <Grid className={classes.headerContent}>
                    <IconButton
                        id="ecal-back-button"
                        aria-label="back"
                        onClick={() => {
                            if ( typeof goToBackPage === 'function') {
                                goToBackPage();
                            }
                        }}
                        className={classes.back}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <IconButton
                        id="ecal-close-button"
                        aria-label="close"
                        onClick={() => {
                            closeWidget();
                        }}
                        className={classes.close}
                    >
                        <Close />
                    </IconButton>
            </Grid>
        </header>
    );
}

WidgetHeader.propTypes = {
    widget: PropTypes.any,
    widgetTheme: PropTypes.any,
    isShowCloseButton: PropTypes.bool,
    isShowBackButton: PropTypes.bool,
    goToBackPage: PropTypes.func,
};

export default observer(WidgetHeader);